function readJsonScript(id, fallback) {
    var node = document.getElementById(id);
    if (!node) {
        return fallback;
    }

    var raw = String(node.textContent || node.innerText || '').trim();
    if (raw === '') {
        return fallback;
    }

    try {
        return JSON.parse(raw);
    } catch (error) {
        return fallback;
    }
}

function isSecureContextForPwa() {
    return window.location.protocol === 'https:'
        || window.location.hostname === 'localhost'
        || window.location.hostname === '127.0.0.1';
}

function isInstallRoute() {
    var path = String((window.location && window.location.pathname) || '').toLowerCase();
    return path === '/install' || path.indexOf('/install/') === 0;
}

function registerServiceWorker() {
    if (typeof window === 'undefined' || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
        return;
    }

    var pwa = readJsonScript('app-pwa-config', {});
    if (!pwa || pwa.enabled !== true || !pwa.service_worker_url) {
        return;
    }

    if (!isSecureContextForPwa()) {
        return;
    }

    // Durante installazione guidata evitiamo registrazioni SW:
    // in alcuni ambienti dietro redirect generano warning rumore.
    if (isInstallRoute()) {
        return;
    }

    window.addEventListener('load', function () {
        navigator.serviceWorker.register(pwa.service_worker_url, {
            scope: pwa.scope || '/'
        }).catch(function (error) {
            console.warn('[Logeon][PWA] Service worker registration failed.', error);
        });
    });
}

registerServiceWorker();

window.PwaRegistration = window.PwaRegistration || {};
window.PwaRegistration.registerServiceWorker = registerServiceWorker;
